module.exports = __webpack_public_path__ + "static/d11-ed9d2e3c404a454b426be1da9af83180.png";